import { useState } from 'react';
import { useConfig } from '../contexts/ConfigContext';
import { useRequestId } from '../contexts/RequestContext';
import { request } from '../lib/request';
import { Account } from '../lib/aoc';

export type UseReportNotMyAccountState = {
    loading: boolean;
    submitted: boolean;
    err: string | Error | null;
    reportNotMyAccount: () => void;
};

const reportedAccounts = new Set<string>();

export const useReportNotMyAccount = (account: Account): UseReportNotMyAccountState => {
    const config = useConfig();
    const requestId = useRequestId();
    const [loading, setLoading] = useState<boolean>(false);
    const [submitted, setSubmitted] = useState<boolean>(reportedAccounts.has(account.idp));
    const [err, setErr] = useState<string | Error | null>(null);

    const reportNotMyAccount = () => {
        if (!requestId || loading || submitted) return;

        setLoading(true);
        setErr(null);

        request(`${config.aocEndpoint}/UpdateOPR`, {
            method: 'POST',
            mode: 'cors',
            redirect: 'follow',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                requestId,
                confirmed: [], // Empty array to indicate "not my account"
                communication: 'User reported: Not my account',
            }),
        })
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error(`Returned response code ${response.status}`);
                }
                reportedAccounts.add(account.idp);
                setSubmitted(true);
            })
            .catch((err) => {
                setErr(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return {
        loading,
        submitted,
        err,
        reportNotMyAccount,
    };
};

export const isAccountReported = (account: Account): boolean => {
    return reportedAccounts.has(account.idp);
};
